// eslint-disable-next-line no-unused-vars
import React from 'react'
import { Dashboard } from '../containers/Dashboard'
import { Masterdata } from '../containers/Masterdata'
import { Optimization } from '../containers/Optimization'
import { DeepInsights } from '../containers/DeepInsights'
import { RackView } from '../containers/RackView'
import { Materials } from '../containers/Administration/Materials'
import { Storageconfigs } from '../containers/Administration/Storageconfigs'
import { Boxtypes } from '../containers/Administration/Boxtypes'
import { EditBoxtypes } from '../containers/Administration/Boxtypes/Edit'
import { Packagetypes } from '../containers/Administration/Packagetypes'
import DeveloperMode from '../containers/Developer/developer'
import { EditStorageConfig } from '../containers/Administration/Storageconfigs/EditStorageConfig'
import {Settings} from "../containers/Settings";
import {CreateBoxtypes} from "../containers/Administration/Boxtypes/Create";

interface NavigationItem {
    [key: string]: {
        path: string
        component: any
    }
}

export const Navigation: NavigationItem = {
    Dashboard: {
        path: '/',
        component: Dashboard,
    },
    MasterdataTab: {
        path: '/masterdata/:tab',
        component: Masterdata,
    },
    Masterdata: {
        path: '/masterdata',
        component: Masterdata,
    },
    Materials: {
        path: '/masterdata/administration/materials',
        component: Materials,
    },
    DeveloperMode: {
        path: '/developer',
        component: DeveloperMode,
    },
    Boxtypes: {
        path: '/masterdata/administration/boxtypes',
        component: Boxtypes,
    },
    BoxtypesCreate: {
        path: '/masterdata/administration/boxtypes/create',
        component: CreateBoxtypes,
    },
    BoxtypesEdit: {
        path: '/masterdata/administration/boxtypes/:uuid/edit',
        component: EditBoxtypes,
    },
    StorageconfigsEdit: {
        path: '/masterdata/administration/storageconfigs/:uuid/edit',
        component: EditStorageConfig,
    },
    Storageconfigs: {
        path: '/masterdata/administration/storageconfigs',
        component: Storageconfigs,
    },
    Packagetypes: {
        path: '/masterdata/administration/packagetypes',
        component: Packagetypes,
    },
    Optimization: {
        path: '/optimization',
        component: Optimization,
    },
    DeepInsights: {
        path: '/deepinsights',
        component: DeepInsights,
    },
    RackView: {
        path: '/rackview',
        component: RackView,
    },
    Settings: {
        path: '/settings',
        component: Settings,
    },
}

export const getDynamicRouteGetters = () => {
    return {
        pages: {
            editBoxtypes: (uuid: string) => `/masterdata/administration/boxtypes/${uuid}/edit`,
            editStorageconfigs: (uuid: string) => `/masterdata/administration/storageconfigs/${uuid}/edit`,
        },
    }
};
export default Navigation
